import React from 'react';
import { Carousel } from 'nuka-carousel';
import { useWidth } from 'utils';
import { slideDataCollectionContents, slideDataCollectionImages } from './constants';
import { DataCollectionScroll } from './dataCollectionScroll';
import { LandingSvg } from '../../../../../assets';

export const DataCollection = () => {
    const width = useWidth();

    const returnSlidesToShow = () => {
        if (width < 768) {
            return 1;
        } else if (width < 968) {
            return 2;
        } else if (width < 1280) {
            return 2.5;
        } else {
            return 3;
        }
    };

    return (
        <div>
            <div className="complate-aba-care-wrapper" style={{ padding: width < 1280 ? '0' : '48px 0 0 0' }}>
                <div className="complate-aba-care-box " style={{ justifyContent: 'flex-end' }}>
                    <div className="complate-aba-care-content-side">
                        <div
                            className="complate-aba-care-content-side-flag"
                            style={{ color: '#7E22CE', background: '#FAF5FF', borderColor: '#F3E8FF' }}
                        >
                            Data Collection
                        </div>
                        <h3 className={`complate-aba-care-content-side-title`}>Clinical excellence without the paperwork burden.</h3>
                        <p className={`complate-aba-care-content-side-text`}>
                            Empower your therapists with intuitive tools designed for the unique needs of ABA data collection. Capture data
                            in real-time, offline or online
                        </p>
                    </div>
                </div>
            </div>

            {width <= 1279 ? (
                <div style={{ paddingBottom: 42 }}>
                    <Carousel className="carousel-box" showArrows="hover" scrollDistance="slide" wrapMode="nowrap">
                        {slideDataCollectionContents.map((item, index) => (
                            <div
                                key={index}
                                className="slider-card-box"
                                style={{ flex: `0 0 calc(${100 / returnSlidesToShow()}% - 24px)`, marginRight: 24 }}
                            >
                                <img
                                    style={{ border: '8px solid rgb(245, 243, 255)' }}
                                    className="slider-card-image"
                                    src={item.image}
                                    alt="slider-image"
                                />

                                <div style={{ marginLeft: 8 }}>
                                    <h4 style={{ color: 'rgb(168, 85, 247)' }}>{item.title}</h4>
                                    <p>{item.text}</p>
                                </div>
                            </div>
                        ))}
                    </Carousel>
                </div>
            ) : (
                <DataCollectionScroll cardData={slideDataCollectionContents} images={slideDataCollectionImages} />
            )}
        </div>
    );
};
